module.exports = __webpack_public_path__ + "static/media/ask-brooklyn.d19bea12.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/ask-brooklyn.png
 ** module id = 203
 ** module chunks = 0
 **/